import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "xs_consent_v1";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) {
        // delay so it doesn't fight the splash animation
        const t = setTimeout(() => setShow(true), 2800);
        return () => clearTimeout(t);
      }
    } catch {}
  }, []);

  if (!show) return null;

  const accept = () => {
    try { localStorage.setItem(KEY, JSON.stringify({ ok: true, at: Date.now() })); } catch {}
    setShow(false);
  };

  return (
    <div
      className="xs-cookie-banner"
      data-testid="cookie-banner"
      role="dialog"
      aria-live="polite"
    >
      <div className="xs-cookie-text">
        this site uses <strong>privacy-first, cookieless analytics</strong>.
        no personal data or cookies are stored. we collect anonymous usage data to improve the platform.
      </div>
      <div className="xs-cookie-actions">
        <Link
          to="/privacy"
          className="xs-btn ghost"
          data-testid="cookie-learn-more"
          style={{ minHeight: 36, padding: "6px 14px" }}
        >
          learn more
        </Link>
        <button
          className="xs-btn primary"
          onClick={accept}
          data-testid="cookie-accept"
          style={{ minHeight: 36, padding: "6px 18px" }}
        >
          accept
        </button>
      </div>
    </div>
  );
}
